import React from 'react';
import { toast, useSonner, type ToasterProps, type Action } from 'sonner';

// Shared no-overlay policy also covers legacy Sonner callers.
const content = (value: React.ReactNode | (() => React.ReactNode)) => typeof value === 'function' ? value() : value;
const actionButton = (action: React.ReactNode | Action, dismiss: () => void) => {
  if (action && typeof action === 'object' && 'onClick' in action && 'label' in action) {
    return <button type="button" className="ml-3 underline" onClick={event => {action.onClick(event); dismiss();}}>{action.label}</button>;
  }
  return action as React.ReactNode;
};
const Toaster = (_props: ToasterProps) => {
  const { toasts } = useSonner();
  return <section aria-label="Action messages" aria-live="polite">
    {toasts.filter(item => !item.delete).map(item => <div key={item.id} role={item.type === 'error' ? 'alert' : 'status'} className="m-4 rounded-md border border-cw bg-cw-card p-3 text-sm">
      {item.jsx || <><strong>{content(item.title)}</strong>{item.description && <p>{content(item.description)}</p>}</>}
      {actionButton(item.action, () => toast.dismiss(item.id))}
      {actionButton(item.cancel, () => toast.dismiss(item.id))}
      <button type="button" className="ml-3 underline" onClick={() => toast.dismiss(item.id)}>Dismiss</button>
    </div>)}
  </section>;
};
export { Toaster, toast };
